import { useGlobalKeyboardShortcuts } from "@/hooks/useKeyboardShortcuts";
import { KeyboardShortcutsDialog } from "@/components/ui/keyboard-shortcuts-dialog";

/**
 * Provider component that must be rendered inside Router context
 * Initializes global keyboard shortcuts and renders the shortcuts dialog
 */
export function GlobalKeyboardShortcutsProvider() {
  const shortcuts = useGlobalKeyboardShortcuts();
  
  return <KeyboardShortcutsDialog shortcuts={shortcuts} />;
}
